<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <circle class="a" cx="12" cy="5.248" r="3" />

        <circle class="a" cx="3.75" cy="18.748" r="3" />

        <circle class="a" cx="20.25" cy="18.748" r="3" />

        <line class="a" x1="6.75" y1="18.748" x2="17.25" y2="18.748" />

        <line class="a" x1="13.659" y1="7.748" x2="18.941" y2="16.048" />

        <line class="a" x1="10.341" y1="7.748" x2="5.059" y2="16.048" />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'HierarchyIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
